"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[592],{

/***/ 1592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _app_constants_routes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9510);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);




var IsOffline = function() {
    var asPath = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)().asPath;
    var isNotOffLinePage = asPath !== _app_constants_routes__WEBPACK_IMPORTED_MODULE_3__/* .OFFLINE_PAGE */ .u9;
    var topPositionPages = [
        _app_constants_routes__WEBPACK_IMPORTED_MODULE_3__/* .ERROR_PAGE */ .fP,
        _app_constants_routes__WEBPACK_IMPORTED_MODULE_3__/* .MISSING_PAGE */ .aB
    ];
    var positionClassName = topPositionPages.includes(asPath) ? "top-0" : "bottom-0";
    var isOffline = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return !navigator.onLine;
    }, [
        navigator.onLine
    ]);
    return isOffline && isNotOffLinePage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "bg-orange-400 text-white\n    fixed flex justify-center w-full py-1 text-xs ".concat(positionClassName),
        children: "Offline Mode"
    });
};
/* harmony default export */ __webpack_exports__["default"] = (IsOffline);


/***/ })

}]);